import React, { useState } from 'react'
import { Card, CardContent, CardTitle, CardDescription, CardFooter } from '../ui/Card'

const HIDE_DURATION_DAYS = 7

const CallToActionCards = ({ creditReportSolosettles = [] }) => {
  const STATIC_CARD_KEYS = ['soloSettle', 'debtAnswer']
  const initializeHiddenState = () => {
    const state = {}
    STATIC_CARD_KEYS.forEach(cardKey => {
      const hiddenUntil = localStorage.getItem(`hidden_${cardKey}`)
      if (hiddenUntil && new Date(hiddenUntil) > new Date()) {
        state[cardKey] = true
      } else {
        if (hiddenUntil) {
          localStorage.removeItem(`hidden_${cardKey}`)
        }
        state[cardKey] = false
      }
    })
    return state
  }
  const [hiddenCards, setHiddenCards] = useState(initializeHiddenState)

  const hideCard = cardKey => {
    const hiddenUntil = new Date()
    hiddenUntil.setDate(hiddenUntil.getDate() + HIDE_DURATION_DAYS)
    localStorage.setItem(`hidden_${cardKey}`, hiddenUntil.toISOString())
    setHiddenCards(prev => ({ ...prev, [cardKey]: true }))
  }

  const allCardsHidden = () => STATIC_CARD_KEYS.every(key => hiddenCards[key])

  if (allCardsHidden()) {
    return null
  }

  return (
    <div className='row mb-8'>
      {creditReportSolosettles
        .filter(item => !item.has_submitted_offer)
        .map(item => {
          const cardKey = `crSolosettle_${item.collection_account_id || item.document_id}`

          return (
            <div key={cardKey} className='col-12 mb-4'>
              <Card className='border-primary'>
                <CardContent>
                  <CardTitle>
                    <h2 className='text-primary'>
                      {item.resume_url ? (
                        <a
                          href={item.resume_url}
                          className='text-primary text-decoration-none'
                          data-remote='false'
                          data-turbolinks='false'
                        >
                          Settle with {item.creditor_name || 'Your Collector'}
                        </a>
                      ) : (
                        <>Settle with {item.creditor_name || 'Your Collector'}</>
                      )}
                    </h2>
                  </CardTitle>
                  <CardDescription className='mb-3'>
                    {item.current_balance ? (
                      <>
                        You have a debt of {item.current_balance}. Let SoloSettle help you negotiate
                        a settlement.
                      </>
                    ) : (
                      <>Let SoloSettle help you negotiate a settlement with your collector.</>
                    )}
                  </CardDescription>
                  {item.resume_url && (
                    <CardFooter>
                      <a
                        href={item.resume_url}
                        className='btn btn-outline-primary fs-6'
                        data-remote='false'
                        data-turbolinks='false'
                      >
                        Continue Settlement
                      </a>
                    </CardFooter>
                  )}
                </CardContent>
              </Card>
            </div>
          )
        })}

      {!hiddenCards.soloSettle && (
        <div className='col-12 mb-4'>
          <Card>
            <CardContent>
              <div className='d-flex justify-content-between align-items-start'>
                <CardTitle>
                  <h2>Try SoloSettle</h2>
                </CardTitle>
                <button
                  onClick={() => hideCard('soloSettle')}
                  className='btn-close'
                  style={{ transform: 'scale(1.5)' }}
                  aria-label='Hide SoloSettle Card'
                  title='Hide SoloSettle Card'
                />
              </div>
              <CardDescription>
                Are you ready to resolve your debt once and for all? SoloSettle makes it easy to
                settle with your collector.
              </CardDescription>
              <CardFooter>
                <a href='/solosettle' className='btn btn-primary fs-6'>
                  Learn More
                </a>
              </CardFooter>
            </CardContent>
          </Card>
        </div>
      )}

      {!hiddenCards.debtAnswer && (
        <div className='col-12 mb-4'>
          <Card>
            <CardContent>
              <div className='d-flex justify-content-between align-items-start'>
                <CardTitle>
                  <h2>File an Answer on your Lawsuit</h2>
                </CardTitle>
                <button
                  onClick={() => hideCard('debtAnswer')}
                  className='btn-close'
                  style={{ transform: 'scale(1.5)' }}
                  aria-label='Hide Debt Answer Card'
                  title='Hide Debt Answer Card'
                />
              </div>
              <CardDescription>
                You made an offer to settle but you haven't filed an Answer yet on your lawsuit.
                Filing an Answer is crucial for settling.
              </CardDescription>
              <CardFooter>
                <a href='/debt_answer' className='btn btn-primary fs-6'>
                  File an Answer
                </a>
              </CardFooter>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  )
}

export default CallToActionCards
